import React, { createContext, useContext } from "react";
import {
  useAgendaWeather,
  type UseAgendaWeatherResult,
} from "../hooks/useAgendaWeather";

const AgendaWeatherContext = createContext<UseAgendaWeatherResult | null>(null);

type AgendaWeatherProviderProps = {
  enabled: boolean;
  date: string;
  children: React.ReactNode;
};

export function AgendaWeatherProvider({
  enabled,
  date,
  children,
}: AgendaWeatherProviderProps) {
  const value = useAgendaWeather({ enabled, date });

  return (
    <AgendaWeatherContext.Provider value={value}>
      {children}
    </AgendaWeatherContext.Provider>
  );
}

export function useAgendaWeatherContext(): UseAgendaWeatherResult {
  const context = useContext(AgendaWeatherContext);
  if (!context) {
    return {
      data: null,
      loading: false,
      error: false,
      location: null,
      primaryCityWeather: null,
      cityByName: new Map(),
      hourRainByCity: new Map(),
      scheduleIdsAtRisk: new Set(),
    };
  }

  return context;
}
